import {
	productTagContainerSX,
	productTagLabelSX,
} from '@/components/content/ProductDetails/styles/productTag';
import { getProductTagProps } from '@/components/content/ProductDetails/utils';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { Box, Typography } from '@mui/material';
import { FC, useContext } from 'react';

export const ProductTag: FC = () => {
	const ProductDetailsLabels = useLocalization('productDetail');
	const { settings } = useSettings();

	const { selection } = useContext(ContentContext) as ReturnType<typeof useProductDetails> &
		ReturnType<typeof useSkuListTable>;

	const { tagBackgroundColor, labelText } = getProductTagProps(settings.userData, selection?.sku);

	return !!labelText ? (
		<Box sx={productTagContainerSX(tagBackgroundColor)}>
			<Typography sx={productTagLabelSX}>{ProductDetailsLabels[labelText].t()}</Typography>
		</Box>
	) : null;
};
